





























































// vue
import { defineComponent, ref, Ref, computed } from '@vue/composition-api'

// componnents
import { PageHeader, ButtonExport, AccordionFilters } from '@/components'
import { Modal } from '@/components/general'
import { LiquidacionControlTableList, LiquidacionControlFormCreateEdit, FiltersLiquidacionControl as Filters } from '@/components/dailyControl'

// services
import { LiquidacionControlService } from '@/services/dailyControl'

// models
import { Paginator } from '@/models'
import { LiquidacionControl, LiquidacionControlForm, FiltersLiquidacionControl } from '@/models/dailyControl'

// utils
import { loading, alerts, getFullNameFormat } from '@/utils'

// constants
import { actionFormTypes } from '@/constants'

const liquidacionControlDefault: LiquidacionControlForm = {
  employee_id: null,
  liquidacion_type_id: null,
  register_date: null,
  discount_date: null,
  amount: 0,
  observations: ''
}

export default defineComponent({
  name: 'LiquidacionControlIndex',
  components: {
    PageHeader,
    LiquidacionControlTableList,
    Modal,
    LiquidacionControlFormCreateEdit,
    ButtonExport,
    AccordionFilters,
    Filters
  },
  setup () {
    const showModal = ref(false)
    const title = 'Control de Liquidaciones'
    const actionForm = ref(actionFormTypes)
    const idEdit: Ref<number|null> = ref(null)
    const titleModal = computed(() => {
      if (actionForm.value === 'update') {
        return 'Editar Control de Liquidacion'
      }
      return 'Crear Control de Liquidacion'
    })
    const items = [
      {
        text: 'Dashboard',
        to: { name: 'home' }
      },
      {
        text: 'Control de Liquidaciones',
        active: true
      }
    ]
    const pagination: Ref<Paginator> = ref({
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    })
    const filters: Ref<FiltersLiquidacionControl> = ref({
      registerDate: null,
      applyDate: null,
      employee: null,
      liquidacionType: null
    })
    const liquidacionControl: Ref<LiquidacionControlForm> = ref(liquidacionControlDefault)
    const allLiquidacionControl: Ref<LiquidacionControl[]> = ref([])
    const getLiquidacionControlWithPagination = async () => {
      loading('show')
      const res = await LiquidacionControlService.getWithPagination(pagination.value.perPage, pagination.value.currentPage, filters.value)
      pagination.value = res.pagination
      allLiquidacionControl.value = res.objects
      loading('hide')
    }
    getLiquidacionControlWithPagination()
    const addNew = () => {
      actionForm.value = 'save'
      showModal.value = true
      liquidacionControl.value = {
        ...liquidacionControlDefault
      }
    }
    const saveSuccess = () => {
      showModal.value = false
      actionForm.value = 'save'
      liquidacionControl.value = {
        ...liquidacionControlDefault
      }
      idEdit.value = null
      getLiquidacionControlWithPagination()
    }
    const editItem = (item: LiquidacionControl) => {
      liquidacionControl.value = {
        employee_id: item.employee_id,
        liquidacion_type_id: item.liquidacion_type_id,
        register_date: item.register_date,
        discount_date: item.discount_date,
        amount: item.amount,
        observations: item.observations
      }
      idEdit.value = Number(item.id)
      actionForm.value = 'update'
      showModal.value = true
    }

    const deleteItem = async (item: LiquidacionControl) => {
      const msg = `Seguro que desea eliminar la liquidación del Empleado: ${item.employee.fullName}, con fecha de: ${item.register_date}`
      const confirm = await alerts.confirm(msg)
      if (confirm) {
        loading('show')
        await LiquidacionControlService.delete(item.id)
        alerts.success()
        getLiquidacionControlWithPagination()
      }
    }

    const changePage = (page: number) => {
        pagination.value.currentPage = page
        getLiquidacionControlWithPagination()
    }

    const changePerPage = (perPage: number) => {
        pagination.value.perPage = perPage
        pagination.value.currentPage = 1
        getLiquidacionControlWithPagination()
    }

    const headersExcel = [
      { text: 'Fecha de Registro', value: 'register_date' },
      { text: 'Fecha de Descuento', value: 'discount_date' },
      { text: 'Empleado', value: 'employee' },
      { text: 'Importe', value: 'amount' },
      { text: 'Tipo de Adelanto', value: 'liquidacionType' }
    ]

    const itemsExcel = computed(() => {
      return allLiquidacionControl.value.map(item => {
        return {
          ...item,
          liquidacionType: item.liquidacionType.name,
          employee: getFullNameFormat(item.employee)
        }
      })
    })

    const getAllitems = async () => {
      allLiquidacionControl.value = await LiquidacionControlService.getAll(filters.value)
    }

    const getByFilters = () => {
      pagination.value.currentPage = 1
      getLiquidacionControlWithPagination()
    }

    const clearFilters = () => {
      pagination.value.currentPage = 1
      filters.value = {
        registerDate: null,
        applyDate: null,
        employee: null,
        liquidacionType: null
      }
      getLiquidacionControlWithPagination()
    }

    return {
      items,
      title,
      addNew,
      showModal,
      titleModal,
      liquidacionControl,
      saveSuccess,
      allLiquidacionControl,
      deleteItem,
      idEdit,
      editItem,
      actionForm,
      pagination,
      changePage,
      changePerPage,
      headersExcel,
      itemsExcel,
      getAllitems,
      filters,
      getByFilters,
      clearFilters
    }
  }
})
